module.exports = __webpack_public_path__ + "static/img/img_logo.4b1534c0.png";